// src/translations/controls.js
export const controlsTranslations = {
  en: {
    // Controles Organizacionales (5.x)
    '5.1': 'Information security policies',
    '5.2': 'Information security roles',
    '5.3': 'Segregation of duties',
    '5.4': 'Management responsibilities',
    '5.5': 'Contact with authorities',
    '5.6': 'Contact with special interest groups',
    '5.7': 'Threat intelligence',
    '5.8': 'Information security in project management',
    '5.9': 'Inventory of information and assets',
    '5.10': 'Acceptable use of information',
    '5.11': 'Return of assets',
    '5.12': 'Classification of information',
    '5.13': 'Labeling of information',
    '5.14': 'Information transfer',
    '5.15': 'Access control',
    '5.16': 'Identity management',
    '5.17': 'Authentication information',
    '5.18': 'Access rights',
    '5.19': 'Information security in supplier relationships',
    '5.20': 'Addressing information security in supplier agreements',
    '5.21': 'Managing information security in the ICT supply chain',
    '5.22': 'Monitoring, review and change management of supplier services',
    '5.23': 'Information security for use of cloud services',
    '5.24': 'Information security incident management planning',
    '5.25': 'Assessment and decision on information security events',
    '5.26': 'Response to information security incidents',
    '5.27': 'Learning from information security incidents',
    '5.28': 'Collection of evidence',
    '5.29': 'Information security during disruption',
    '5.30': 'ICT readiness for business continuity',
    '5.31': 'Legal, statutory, regulatory and contractual requirements',
    '5.32': 'Intellectual property rights',
    '5.33': 'Protection of records',
    '5.34': 'Privacy and protection of PII',
    '5.35': 'Independent review of information security',
    '5.36': 'Compliance with policies and standards',
    '5.37': 'Documented operating procedures',
    
    // Controles de Personas (6.x)
    '6.1': 'Screening',
    '6.2': 'Terms and conditions of employment',
    '6.3': 'Information security awareness, education and training',
    '6.4': 'Disciplinary process',
    '6.5': 'Responsibilities after termination of employment',
    '6.6': 'Confidentiality or non-disclosure agreements',
    '6.7': 'Remote working',
    '6.8': 'Information security event reporting',
    
    // Controles Físicos (7.x)
    '7.1': 'Physical security perimeters',
    '7.2': 'Physical entry controls',
    '7.3': 'Securing offices, rooms and facilities',
    '7.4': 'Physical security monitoring',
    '7.5': 'Protecting against physical and environmental threats',
    '7.6': 'Working in secure areas',
    '7.7': 'Clear desk and clear screen',
    '7.8': 'Equipment siting and protection',
    '7.9': 'Security of assets off-premises',
    '7.10': 'Storage media',
    '7.11': 'Supporting utilities',
    '7.12': 'Cabling security',
    '7.13': 'Equipment maintenance',
    '7.14': 'Secure disposal or re-use of equipment',
    
    // Controles Tecnológicos (8.x)
    '8.1': 'User endpoint devices',
    '8.2': 'Privileged access rights',
    '8.3': 'Information access restriction',
    '8.4': 'Access to source code',
    '8.5': 'Secure authentication',
    '8.6': 'Capacity management',
    '8.7': 'Protection against malware',
    '8.8': 'Management of technical vulnerabilities',
    '8.9': 'Configuration management',
    '8.10': 'Information deletion',
    '8.11': 'Data masking',
    '8.12': 'Data leakage prevention',
    '8.13': 'Information backup',
    '8.14': 'Redundancy of information processing facilities',
    '8.15': 'Logging',
    '8.16': 'Monitoring activities',
    '8.17': 'Clock synchronization',
    '8.18': 'Use of privileged utility programs',
    '8.19': 'Installation of software on operational systems',
    '8.20': 'Networks security',
    '8.21': 'Security of network services',
    '8.22': 'Segregation of networks',
    '8.23': 'Web filtering',
    '8.24': 'Use of cryptography',
    '8.25': 'Secure development life cycle',
    '8.26': 'Application security requirements',
    '8.27': 'Secure system architecture and engineering principles',
    '8.28': 'Secure coding',
    '8.29': 'Security testing in development and acceptance',
    '8.30': 'Outsourced development',
    '8.31': 'Separation of development, test and production environments',
    '8.32': 'Change management',
    '8.33': 'Test information',
    '8.34': 'Protection of information systems during audit testing'
  },
  es: {
    '5.1': 'Políticas de seguridad de la información',
    '5.2': 'Funciones de seguridad de la información',
    '5.3': 'Separación de funciones',
    '5.4': 'Responsabilidades de gestión',
    '5.5': 'Contacto con las autoridades',
    '5.6': 'Contacto con grupos de interés especial',
    '5.7': 'Inteligencia de amenazas',
    '5.8': 'Seguridad en gestión de proyectos',
    '5.9': 'Inventario de activos',
    '5.10': 'Uso aceptable de la información',
    '5.11': 'Devolución de activos',
    '5.12': 'Clasificación de la información',
    '5.13': 'Etiquetado de la información',
    '5.14': 'Transferencia de información',
    '5.15': 'Control de acceso',
    '5.16': 'Gestión de identidades',
    '5.17': 'Información de autenticación',
    '5.18': 'Derechos de acceso',
    '5.19': 'Seguridad en proveedores',
    '5.20': 'Acuerdos con proveedores',
    '5.21': 'Cadena de suministro TIC',
    '5.22': 'Monitoreo de proveedores',
    '5.23': 'Servicios en la nube',
    '5.24': 'Planificación de incidentes',
    '5.25': 'Evaluación de eventos',
    '5.26': 'Respuesta a incidentes',
    '5.27': 'Aprendizaje de incidentes',
    '5.28': 'Obtención de pruebas',
    '5.29': 'Seguridad durante interrupciones',
    '5.30': 'Preparación TIC',
    '5.31': 'Requisitos legales',
    '5.32': 'Propiedad intelectual',
    '5.33': 'Protección de registros',
    '5.34': 'Privacidad y PII',
    '5.35': 'Revisión independiente',
    '5.36': 'Cumplimiento de políticas',
    '5.37': 'Procedimientos operativos',
    '6.1': 'Verificación de antecedentes',
    '6.2': 'Términos de empleo',
    '6.3': 'Concienciación y capacitación',
    '6.4': 'Proceso disciplinario',
    '6.5': 'Responsabilidades post-empleo',
    '6.6': 'Acuerdos de confidencialidad',
    '6.7': 'Trabajo remoto',
    '6.8': 'Reporte de eventos',
    '7.1': 'Perímetros de seguridad física',
    '7.2': 'Control de entrada físico',
    '7.3': 'Seguridad de oficinas',
    '7.4': 'Monitoreo de seguridad física',
    '7.5': 'Protección contra amenazas físicas',
    '7.6': 'Trabajo en áreas seguras',
    '7.7': 'Escritorio y pantalla limpia',
    '7.8': 'Ubicación de equipos',
    '7.9': 'Seguridad de activos externos',
    '7.10': 'Medios de almacenamiento',
    '7.11': 'Servicios de soporte',
    '7.12': 'Seguridad del cableado',
    '7.13': 'Mantenimiento de equipos',
    '7.14': 'Eliminación segura',
    '8.1': 'Dispositivos de punto final',
    '8.2': 'Accesos privilegiados',
    '8.3': 'Restricción de acceso',
    '8.4': 'Acceso al código fuente',
    '8.5': 'Autenticación segura',
    '8.6': 'Gestión de capacidad',
    '8.7': 'Protección contra malware',
    '8.8': 'Gestión de vulnerabilidades',
    '8.9': 'Gestión de configuración',
    '8.10': 'Eliminación de información',
    '8.11': 'Enmascaramiento de datos',
    '8.12': 'Prevención de fuga datos',
    '8.13': 'Copia de seguridad',
    '8.14': 'Redundancia',
    '8.15': 'Registro',
    '8.16': 'Monitoreo de actividades',
    '8.17': 'Sincronización de relojes',
    '8.18': 'Programas privilegiados',
    '8.19': 'Instalación de software',
    '8.20': 'Seguridad de redes',
    '8.21': 'Seguridad servicios red',
    '8.22': 'Segregación de redes',
    '8.23': 'Filtrado web',
    '8.24': 'Criptografía',
    '8.25': 'Desarrollo seguro',
    '8.26': 'Requisitos aplicaciones',
    '8.27': 'Arquitectura segura',
    '8.28': 'Codificación segura',
    '8.29': 'Pruebas de seguridad',
    '8.30': 'Desarrollo externalizado',
    '8.31': 'Separación de entornos',
    '8.32': 'Gestión de cambios',
    '8.33': 'Información de pruebas',
    '8.34': 'Protección durante auditorías'
  },
  pt: {
    '5.1': 'Políticas de segurança da informação',
    '5.2': 'Funções de segurança da informação',
    '5.3': 'Separação de funções',
    '5.4': 'Responsabilidades da gestão',
    '5.5': 'Contacto com as autoridades',
    '5.6': 'Contacto com grupos de interesse especial',
    '5.7': 'Inteligência de ameaças',
    '5.8': 'Segurança na gestão de projetos',
    '5.9': 'Inventário de ativos',
    '5.10': 'Uso aceitável da informação',
    '5.11': 'Devolução de ativos',
    '5.12': 'Classificação da informação',
    '5.13': 'Rotulagem da informação',
    '5.14': 'Transferência de informação',
    '5.15': 'Controlo de acesso',
    '5.16': 'Gestão de identidades',
    '5.17': 'Informação de autenticação',
    '5.18': 'Direitos de acesso',
    '5.19': 'Segurança em relações com fornecedores',
    '5.20': 'Acordos com fornecedores',
    '5.21': 'Cadeia de fornecimento de TIC',
    '5.22': 'Monitorização de fornecedores',
    '5.23': 'Serviços em nuvem',
    '5.24': 'Planeamento de incidentes',
    '5.25': 'Avaliação de eventos',
    '5.26': 'Resposta a incidentes',
    '5.27': 'Aprendizagem com incidentes',
    '5.28': 'Obtenção de evidências',
    '5.29': 'Segurança durante interrupções',
    '5.30': 'Preparação para continuidade de TIC',
    '5.31': 'Requisitos legais e contratuais',
    '5.32': 'Direitos de propriedade intelectual',
    '5.33': 'Proteção de registos',
    '5.34': 'Privacidade e proteção de PII',
    '5.35': 'Revisão independente',
    '5.36': 'Conformidade com políticas',
    '5.37': 'Procedimentos operacionais documentados',
    '6.1': 'Verificação de antecedentes',
    '6.2': 'Termos e condições de emprego',
    '6.3': 'Conscientização e capacitação',
    '6.4': 'Processo disciplinar',
    '6.5': 'Responsabilidades pós-emprego',
    '6.6': 'Acordos de confidencialidade',
    '6.7': 'Trabalho remoto',
    '6.8': 'Comunicação de eventos',
    '7.1': 'Perímetros de segurança física',
    '7.2': 'Controlos de entrada física',
    '7.3': 'Segurança de escritórios e instalações',
    '7.4': 'Monitorização de segurança física',
    '7.5': 'Proteção contra ameaças físicas',
    '7.6': 'Trabalho em áreas seguras',
    '7.7': 'Secretária limpa e ecrã limpo',
    '7.8': 'Localização e proteção de equipamentos',
    '7.9': 'Segurança de ativos fora das instalações',
    '7.10': 'Suportes de armazenamento',
    '7.11': 'Utilidades de suporte',
    '7.12': 'Segurança de cablagem',
    '7.13': 'Manutenção de equipamentos',
    '7.14': 'Eliminação segura de equipamentos',
    '8.1': 'Dispositivos de ponto final',
    '8.2': 'Direitos de acesso privilegiados',
    '8.3': 'Restrição de acesso à informação',
    '8.4': 'Acesso ao código fonte',
    '8.5': 'Autenticação segura',
    '8.6': 'Gestão de capacidade',
    '8.7': 'Proteção contra malware',
    '8.8': 'Gestão de vulnerabilidades',
    '8.9': 'Gestão de configuração',
    '8.10': 'Eliminação de informação',
    '8.11': 'Mascaramento de dados',
    '8.12': 'Prevenção de fuga de dados',
    '8.13': 'Cópia de segurança',
    '8.14': 'Redundância',
    '8.15': 'Registo',
    '8.16': 'Monitorização de atividades',
    '8.17': 'Sincronização de relógios',
    '8.18': 'Programas privilegiados',
    '8.19': 'Instalação de software',
    '8.20': 'Segurança de redes',
    '8.21': 'Segurança de serviços de rede',
    '8.22': 'Segregação de redes',
    '8.23': 'Filtragem web',
    '8.24': 'Criptografia',
    '8.25': 'Ciclo de vida de desenvolvimento seguro',
    '8.26': 'Requisitos de segurança de aplicações',
    '8.27': 'Arquitetura segura',
    '8.28': 'Codificação segura',
    '8.29': 'Testes de segurança',
    '8.30': 'Desenvolvimento externalizado',
    '8.31': 'Separação de ambientes',
    '8.32': 'Gestão de mudanças',
    '8.33': 'Informação de teste',
    '8.34': 'Proteção durante auditorias'
  }
};

export const getControlName = (controlId, language) => {
  const langMap = controlsTranslations[language] || controlsTranslations.es;
  return langMap[controlId] || controlId;
};